/**
 * Premium and specialty experiences by park.
 * Zone names match zoneOrderByPark (data/rideOptionsByPark) for itinerary zone ordering.
 * availability: active | seasonal | limited | discontinued
 */
const experiencesByPark = {
  "Magic Kingdom": [
    {
      name: "Bibbidi Bobbidi Boutique",
      location: "Fantasyland",
      zone: "Fantasyland",
      description: "Prince/Princess makeovers",
      category: "Character Experience",
      availability: "active"
    },
    {
      name: "The Harmony Barber Shop",
      location: "Main Street, U.S.A.",
      zone: "Main Street, U.S.A.",
      description: "Classic haircuts, sometimes with pixie dust add-ons",
      category: "Classic Experience",
      availability: "active",
      availabilityNotes: "Limited daily slots; reservation recommended."
    },
    {
      name: "Capture Your Moment Photo Session",
      location: "Select park areas",
      zone: "Main Street, U.S.A.",
      description: "Private 20-min photo shoots in select park areas",
      category: "Photography",
      availability: "active"
    },
    {
      name: "Keys to the Kingdom Tour",
      location: "Park-wide",
      zone: "Main Street, U.S.A.",
      description: "5-hour backstage tour including the Utilidors, history, behind-the-scenes",
      category: "Backstage Tour",
      availability: "active",
      availabilityNotes: "Age restrictions apply; availability varies by date."
    }
  ],
  "EPCOT": [
    {
      name: "Behind the Seeds Tour",
      location: "The Land pavilion",
      zone: "World Nature",
      description: "Greenhouse tour in The Land pavilion",
      category: "Educational Tour",
      availability: "active"
    },
    {
      name: "DiveQuest",
      location: "The Seas pavilion",
      zone: "World Nature",
      description: "Scuba diving in The Seas pavilion, requires certification",
      category: "Aquatic Experience",
      availability: "limited",
      availabilityNotes: "Offered intermittently; not always bookable year-round."
    },
    {
      name: "Festival Culinary Events (EPCOT)",
      location: "World Showcase",
      zone: "Mexico",
      description: "Festival premium food & beverage events (varies by festival and season)",
      category: "Culinary Experience",
      availability: "seasonal",
      availabilityNotes: "This is an umbrella category; specific events change with each festival."
    },
    {
      name: "Capture Your Moment (EPCOT)",
      location: "Select park areas",
      zone: "World Celebration",
      description: "Private 20-min photo shoots in select park areas",
      category: "Photography",
      availability: "active"
    }
  ],
  "Animal Kingdom": [
    {
      name: "Wild Africa Trek",
      location: "Africa",
      zone: "Africa",
      description: "3-hour guided trek with rope bridges, private safari truck, African meal",
      category: "Adventure Experience",
      availability: "active"
    },
    {
      name: "Caring for Giants",
      location: "Africa",
      zone: "Africa",
      description: "Elephant backstage tour",
      category: "Animal Encounter",
      availability: "active"
    },
    {
      name: "Up Close with Rhinos",
      location: "Africa",
      zone: "Africa",
      description: "Behind-the-scenes rhino experience",
      category: "Animal Encounter",
      availability: "seasonal",
      availabilityNotes: "Often rotates on/off; treat as limited-time."
    },
    {
      name: "Savor the Savanna",
      location: "Africa",
      zone: "Africa",
      description: "Private safari with food & drinks",
      category: "Culinary Experience",
      availability: "seasonal",
      availabilityNotes: "Seasonal and may pause for long stretches."
    },
    {
      name: "Capture Your Moment (Animal Kingdom)",
      location: "Select park areas",
      zone: "Discovery Island",
      description: "Private 20-min photo shoots in select park areas",
      category: "Photography",
      availability: "active"
    }
  ],
  "Hollywood Studios": [
    {
      name: "Droid Depot",
      location: "Star Wars: Galaxy's Edge",
      zone: "Star Wars: Galaxy's Edge",
      description: "Custom astromech droids",
      category: "Interactive Experience",
      availability: "active"
    },
    {
      name: "Savi's Workshop",
      location: "Star Wars: Galaxy's Edge",
      zone: "Star Wars: Galaxy's Edge",
      description: "Custom lightsabers",
      category: "Interactive Experience",
      availability: "active"
    },
    {
      name: "Capture Your Moment (Hollywood Studios)",
      location: "Select park areas",
      zone: "Hollywood Boulevard",
      description: "Private 20-min photo shoots in select park areas",
      category: "Photography",
      availability: "active"
    }
  ]
};

function getExperiencesByParks(selectedParks = []) {
  if (!Array.isArray(selectedParks) || selectedParks.length === 0) {
    return [];
  }
  const allExperiences = [];
  selectedParks.forEach((park) => {
    if (experiencesByPark[park]) {
      allExperiences.push(...experiencesByPark[park]);
    }
  });
  return allExperiences;
}

function getExperiencesByCategory(selectedParks = [], category = null) {
  const experiences = getExperiencesByParks(selectedParks);
  if (!category) return experiences;
  return experiences.filter((exp) => exp.category === category);
}

function getUniqueCategories(selectedParks = []) {
  const experiences = getExperiencesByParks(selectedParks);
  const categories = [...new Set(experiences.map((exp) => exp.category))];
  return categories.sort();
}

export {
  experiencesByPark,
  getExperiencesByParks,
  getExperiencesByCategory,
  getUniqueCategories
};